// btw-front/src/components/sections/UseCases.jsx
import React, { useMemo } from "react";
import Container from "../ui/Container";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";

export default function UseCases() {
  const { t } = useTranslation();
  const items = useMemo(() => t("usecases.items", { returnObjects: true }) || [], [t]);

  return (
    <section id="usecases" className="btw-section bg-slate-100">
      <Container>
        <Fade direction="up" triggerOnce>
          <div className="max-w-2xl">
            <span className="btw-eyebrow">{t("usecases.eyebrow")}</span>
            <h2 className="btw-h2 mt-4">{t("usecases.title")}</h2>
            <p className="btw-lead">{t("usecases.desc")}</p>
          </div>
        </Fade>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {items.map((it) => (
            <Fade key={it.title} direction="up" triggerOnce>
              <div className="btw-card-hover h-full p-6">
                <div className="text-lg font-semibold text-slate-900">{it.title}</div>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{it.desc}</p>
              </div>
            </Fade>
          ))}
        </div>
      </Container>
    </section>
  );
}
